import { onMounted, onUnmounted } from 'vue';

export function useChartDprResize(chartRef) {
  let dprMediaQuery = null;

  function resize() {
    const chart = chartRef.value?.chart;
    if (!chart) return;

    const { canvas } = chart;

    // Switch to relative width so the container's size is driven by its parent, not the canvas
    canvas.style.width = '100%';

    requestAnimationFrame(() => {
      chart.resize();
      // eslint-disable-next-line no-use-before-define
      observe();
    });
  }

  function observe() {
    dprMediaQuery = window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
    dprMediaQuery.addEventListener('change', resize, { once: true });
  }

  onMounted(() => observe());
  onUnmounted(() => dprMediaQuery?.removeEventListener('change', resize));
}
